import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { Box, Text, xcss } from '@atlaskit/primitives';
import { messages } from './messages';
var captionWrapperStyle = css({
  marginTop: "var(--ds-space-100, 8px)",
  textAlign: 'center',
  position: 'relative',
  color: "var(--ds-text-subtle, #44546F)"
});
var placeholderStyle = xcss({
  color: 'color.text.subtlest',
  position: 'absolute',
  top: 'space.0',
  width: '100%'
});
export var CaptionComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(CaptionComponent, _React$Component);
  var _super = _createSuper(CaptionComponent);
  function CaptionComponent() {
    _classCallCheck(this, CaptionComponent);
    return _super.apply(this, arguments);
  }
  _createClass(CaptionComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        selected = _this$props.selected,
        hasContent = _this$props.hasContent,
        children = _this$props.children,
        dataAttributes = _this$props.dataAttributes,
        formatMessage = _this$props.intl.formatMessage;
      var showPlaceholder = !selected && !hasContent;
      return jsx("div", _extends({
        "data-media-caption": true,
        "data-testid": "media-caption"
      }, dataAttributes, {
        css: captionWrapperStyle
      }), showPlaceholder ? jsx(Box, {
        xcss: placeholderStyle
      }, jsx(Text, null, formatMessage(messages.placeholder))) : null, children);
    }
  }]);
  return CaptionComponent;
}(React.Component);
export default injectIntl(CaptionComponent);